import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {groupsErrorAction} from './actions';
import {leaveGroup} from './groupsService';
import {Group} from './types';

export const useLeaveGroup = () => {
  const dispatch = useDispatch();
  return useCallback(
    async (group: Group) => {
      try {
        return await leaveGroup(group);
      } catch (err) {
        dispatch(groupsErrorAction(err));
        throw err;
      }
    },
    [leaveGroup],
  );
};
